<template>
  <div class="survey-template">
    <table v-if="dataSurvey.survey">
      <thead>
        <tr class="blue accent-4 white-text">
          <th colspan="2">Home Profile</th>
        </tr>
        <tr>
          <th>Question</th>
          <th>Answer</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(items, key) in dataSurvey.survey" :key="key">
          <td>
            <b>{{ homeProfileSchema[key] ? homeProfileSchema[key].label : "" }}</b>
          </td>
          <td v-if="Array.isArray(items)">

            <p v-for="(text, index) in items" :key="index">

              {{
                homeProfileSchema[key].options
                ? homeProfileSchema[key].options[text]
                : ""
              }}

            </p>
          </td>
          <td v-else>

            {{
              homeProfileSchema[key].options
              ? homeProfileSchema[key].options[items]
              : items
            }}
            <span v-if="homeProfileSchema[key].suffix">
              {{ homeProfileSchema[key].suffix }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="height:32px; width:100%;"></div>
    <table>
      <thead>
        <tr>
          <th>
            Home Profile Images
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(view, key) in imagesX" :key="key">
          <td>
            <!--    <div class="col s12 option-title">{{ $_humanize(key) }}</div> -->
            <div class="col s6" v-for="(img, index) in view.images" :key="index">
              <figure style="margin-bottom: 18px; margin-top: 6px;">
                <img :src="img.link" />
                <figcaption>{{ $_humanize(key) }} {{ index + 1 }}</figcaption>
              </figure>

            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div style="height:32px; width:100%;"></div>
    <div v-if="false">
      <div class="section" v-for="(view, key) in imagesX" :key="key">
        <h5 v-if="view.images.length > 0" class="col s12">
          {{ $_humanize(key) }}
        </h5>
        <img v-for="(img, index) in view.images" :key="index" class="col s3" :src="img.link" alt="House Image" />
      </div>
    </div>
  </div>
</template>

<script>
import homeProfileSchema from "@/JsonSchemas/homeProfile.json";
export default {
  name: "HomeProfileReview",
  props: {
    dataSurvey: {
      type: Object,
    },
  },
  data() {
    return {
      homeProfileSchema,
    };
  },
  computed: {
    imagesX() {
      if (!this.dataSurvey) return false;
      const { images } = this.dataSurvey;
      if (!images) return false;

      const { adaptation_plan, ...res } = images;

      return res;
    },
  },
  methods: {
    $_humanize(str) {
      let i,
        frags = str.split("_");
      for (i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(" ");
    },
  },
};
</script>
<style lang="scss" scoped>
table {
  thead {
    background: rgba(0, 0, 0, 0.08);
    padding: 12px;
  }
}

td,
th {
  border: 1px solid lightgray !important;
  padding: 12px;

  p {
    margin: 6px 0px;
  }
}
</style>
